import { render } from "./Educationwin.vue?vue&type=template&id=150060a4&scoped=true"
import script from "./Educationwin.vue?vue&type=script&lang=js"
export * from "./Educationwin.vue?vue&type=script&lang=js"

import "./Educationwin.vue?vue&type=style&index=0&id=150060a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150060a4"]])

export default __exports__